<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const text = field<string>("text", "Default description text...");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:text-quote" accent="container">
    <EditorField :label="t('textLabel')">
      <Textarea v-model="text" class="min-h-20 rounded-sm bg-muted text-[13px]" :placeholder="t('textPlaceholder')" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Card Header Description"
  textLabel: "Description Text"
  textPlaceholder: "Enter description text"
</i18n>
